// app/features/subscription/subscriptionSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Subscription } from "../context";

interface SubscriptionState {
  data: Subscription | null;
  loading: boolean;
  error: string | null;
}

const initialState: SubscriptionState = {
  data: null,
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setSubscription(state, action: PayloadAction<Subscription>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    updateSubscription(state, action: PayloadAction<Partial<Subscription>>) {
      if (state.data) {
        state.data = { ...state.data, ...action.payload };
      }
      state.loading = false;
      state.error = null;
    },
    fetchSubscriptionStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionSuccess(state, action: PayloadAction<Subscription>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSubscriptionFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSubscriptionLoading(state) {
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setSubscription,
  updateSubscription,
  fetchSubscriptionStart,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  resetSubscriptionLoading,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;